import moment from 'moment'

export const provideEndDate = toDate => {
  const today = moment().format('YYYY-MM-DD')
  return toDate !== today ? toDate : moment().subtract(1, 'day').format('YYYY-MM-DD')
}
